import React, { PropTypes, Component } from 'react';
import * as routes from '../../../routes/const';

import styled from 'styled-components';
import { LegacyFilterTypeMap } from '../new-report/Filters/Helpers';
import _ from 'lodash';

import {
  NitroHeading,
  NitroParagraph,
  NitroDivider,
  NitroButton,
  NitroButtonGroup,
  NitroDrawer,
  NitroPanel,
  NitroGrids,
  NitroGrid,
  NitroIcon,
  NitroLinks,
  NitroLoading
} from 'nitro-components';
import { media } from 'style-utils';

const NitroParagraphExtended = styled(NitroParagraph)`
  && {
    overflow-y: auto;
  }
`;

const ScheduleIcon = styled.span`
  position: absolute;
  right: 10px;
  top: 6px;
`;

const ReportPanel = styled.div`
  display: flex;
  flex-direction: column;
  height: 340px !important;
`;

const ReportHeadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 8px 0 8px;
  height: 50px;
`;
const ReportHeading = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 25px; /* fallback */
  max-height: 50px; /* fallback */
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
`;

const ButtonGroupWrapper = styled.div`
  margin-top: auto !important;
  display: flex;
`;

const StyledNitroLinks = styled(NitroLinks)`
  width: 100%;

  visibility: ${props => (props.visibility ? 'visible' : 'hidden')};

  ul {
    width: 100%;
  }

  li:last-of-type {
    &:first-of-type {
      margin-left: 0;
    }

    margin-left: auto;
  }
`;

const StyledLoading = styled(NitroLoading)`
  margin-top: 50px;
`;

const FilterContainer = styled.div`
  display: flex;
  margin: 20px;
  .label {
    flex: 1;
    margin-top: 10px;
  }

  .filter {
    flex: 3;
  }
  flex: 1;
`;

const InsightDrawerDetails = styled.div`
  position: relative;
  flex: 3;
  padding: 18px 0 0px 35px;
  margin: 20px;
  display: flex;

  flex-direction: column;
  justify-content: space-between;

  ${media.mobile`
    width: 100%;
    padding: 0 24px;
  `};
`;

const InsightsDetailDescription = styled.p`
  max-height: 9rem;
`;

const InsightDrawerContent = styled.div`
  display: block;
  margin-top: 20px;
  display: flex;

  .filters {
    flex: 2;
  }
`;

class Filter extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const { filter } = this.props;

    const type = filter.Type;

    console.log({ filter });

    const FilterComponent = LegacyFilterTypeMap[type].component;

    return (
      <FilterContainer>
        <div className="label">{filter.Name}</div>
        <div className="filter">
          <FilterComponent
            filter={{
              label: filter.Value,
              title: filter.Name,
              value: filter.Value || ''
            }}
            action={value => this.props.onChange(filter.Name, value)}
          />
        </div>
      </FilterContainer>
    );
  }
}

class ActiveReport extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { ...this.props.report };
  }

  onChange = (name, value) => {
    console.log({ name, value });

    const config = { ...this.state.legacyReportConfiguration };
    const newParams = config.Parameters.map(p => {
      if (p.Name === name) p.Value = value;
      return p;
    });
    config.Parameters = [...newParams];

    this.setState({
      legacyReportConfiguration: { ...config }
    });
  };

  render() {
    const paras = this.props.report.legacyReportConfiguration.Parameters;

    const filters = paras.map((filter, index) => (
      <Filter key={index} filter={filter} onChange={this.onChange} />
    ));

    const link = { type: 'export', report: { ...this.props.report } };

    return (
      <InsightDrawerContent>
        <div className="filters">{filters}</div>

        <InsightDrawerDetails>
          <section>
            <NitroHeading label={this.props.report.name} variant="secondary" />
            <InsightsDetailDescription>
              {this.props.report.description}
            </InsightsDetailDescription>
          </section>
          <section>
            <NitroDivider noTopPad />

            <NitroButtonGroup align="right" layout="horizontal">
              <NitroButton
                size="compact"
                label="Export"
                icon="export"
                action={() => this.props.handleExport(link)}
              />
            </NitroButtonGroup>
          </section>
        </InsightDrawerDetails>
      </InsightDrawerContent>
    );
  }
}

class ReportsCards extends Component {
  // set exporting status to false for all cards
  state = {
    exporting: [],
    showPanel: false,
    activeReport: {}
  };

  constructor(props) {
    super(props);

    this.exportReportFn = this.props.exportReport.bind(this);
  }
  editReport = report => {
    const { router } = this.context;
    const route = `${routes.REPORTS_BUILDER}/${report.category}/${report.id}`;
    router.push(route);
  };

  getExportCallback = id => {
    const exportingIds = [...this.state.exporting];
    const index = exportingIds.indexOf(id);
    if (index !== -1) exportingIds.splice(index, 1);

    this.setState({
      exporting: exportingIds
    });
  };

  handleLinkClick = link => {
    console.log('link type', link.type, link.report);

    if (link.type === 'export') {
      console.log('start export');

      const exportingIds = [...this.state.exporting];
      exportingIds.push(link.report.id);

      this.setState({
        exporting: exportingIds
      });
      this.exportReportFn(link.report, () =>
        this.getExportCallback(link.report.id)
      );
    } else {
      this.editReport(link.report);
    }
  };

  openPanel = report => {
    this.setState({
      showPanel: true,
      activeReport: report
    });
  };

  closePanel = () => {
    this.setState({
      showPanel: false,
      activeReport: {}
    });
  };

  render() {
    // deep clone to avoide the state mutation problem
    const reports = _.cloneDeep(this.props.reports);
    const cards = reports.map((rawReport, index) => {
      const report = { ...rawReport };
      let scheduleIcon = '';
      if (report.isScheduled === true) {
        scheduleIcon = (
          <ScheduleIcon>
            <NitroIcon name="schedule" size={14} />
          </ScheduleIcon>
        );
      }

      const exportLinks = [
        { label: 'Export', icon: 'export', type: 'export', report }
      ];

      const filterExportLinks = [
        { label: 'Apply Filter', icon: 'edit', type: 'export', report }
      ];

      if (report.category === 'user')
        exportLinks.push({
          label: 'Edit',
          icon: 'edit',
          align: 'right',
          type: 'edit',
          report
        });

      const hasLegacyFilter = report.legacyReportConfiguration
        ? report.legacyReportConfiguration.Parameters.length
        : false;

      const exporting =
        this.state.exporting.length &&
        this.state.exporting.indexOf(report.id) > -1;

      return (
        <NitroGrid grid={4} key={index}>
          <NitroPanel padding="16px" noMargin>
            <ReportPanel>
              {scheduleIcon}

              <ReportHeadingWrapper>
                <ReportHeading>
                  <NitroHeading
                    label={report.name}
                    size="2"
                    variant="secondary"
                    align="center"
                    noMargin
                  />
                </ReportHeading>
              </ReportHeadingWrapper>

              <NitroDivider halfWidth noTopPad />

              <NitroParagraphExtended size="4" variant="base2" align="center">
                {report.description}
              </NitroParagraphExtended>

              <ButtonGroupWrapper>
                {exporting ? <StyledLoading /> : null}
                {!hasLegacyFilter && (
                  <StyledNitroLinks
                    // prevent other link from showing if here is
                    // a exporting in progress already
                    // existing implementation only allow one export at a time
                    visibility={!this.state.exporting.length}
                    layout="horizontal"
                    size="8"
                    data={exportLinks}
                    action={this.handleLinkClick}
                  />
                )}
                {!!hasLegacyFilter && (
                  // prevent other link from showing if here is
                  // a exporting in progress already
                  // existing implementation only allow one export at a time
                  <StyledNitroLinks
                    visibility={!this.state.exporting.length}
                    layout="horizontal"
                    size="8"
                    data={filterExportLinks}
                    action={() => this.openPanel(report)}
                  />
                )}
              </ButtonGroupWrapper>
            </ReportPanel>
          </NitroPanel>
        </NitroGrid>
      );
    });

    return (
      <NitroGrids>
        {cards}

        <NitroDrawer
          isOpen={this.state.showPanel}
          close={this.closePanel}
          height={460}
          padding="0 0 0 60px"
          slideUp
          variant="white"
          iconVariant="base3"
        >
          {this.state.showPanel && (
            <ActiveReport
              report={{ ...this.state.activeReport }}
              handleExport={this.handleLinkClick}
            />
          )}
        </NitroDrawer>
      </NitroGrids>
    );
  }
}

ReportsCards.propTypes = {
  reports: PropTypes.array,
  exportReport: PropTypes.func
};

ReportsCards.contextTypes = {
  router: PropTypes.object
};
export default ReportsCards;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/components/ReportsCards.js